import { get, post } from '@/request/request'

export default {
  list(params) {
    return get('/admin/position/list', params)
  },
  info(params) {
    return get('/admin/position/info', params)
  },
  save(params) {
    return post('/admin/position/save', params)
  },
  delete(params) {
    return post('/admin/position/delete', params)
  },
  perms(params) {
    return get('/admin/position/perms', params)
  },
  permsUpdate(params) {
    return post('/admin/position/perms/update', params)
  }
}
